import { Box, TextField, TextFieldProps } from '@mui/material';
import { forwardRef, Ref } from 'react';
type CAppFormTextFieldProps = TextFieldProps & {
	isViewOnly?: boolean;
	valueViewOnly?: string;
};
const CAppFormTextField = (props: CAppFormTextFieldProps, ref: Ref<HTMLDivElement>) => {
	const { isViewOnly, valueViewOnly, ...otherProps } = props;
	return (
		<>
			{isViewOnly ? (
				<>
					<Box sx={{ fontSize: '0.9rem' }}>{otherProps.label} :</Box>
					<Box sx={{ fontWeight: 600 }}>
						{valueViewOnly ?? (otherProps.value ? otherProps.value.toString() : 'n.c.')}
					</Box>
				</>
			) : (
				<TextField {...otherProps} value={otherProps.value ?? ''} ref={ref} />
			)}
		</>
	);
};

export default forwardRef(CAppFormTextField);
